import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ControlPanelRoutingModule } from './control-panel-routing.module';
import { TransformNumberPipe } from '@app/@shared/pipes/transform-number.pipe';

@NgModule({
  declarations: [],
  imports: [CommonModule, ControlPanelRoutingModule],
  providers: [DatePipe, TransformNumberPipe],
})
export class ControlPanelModule {}
